import { REQUIREMENTS } from "../../lib/site-data";
import { CheckCircle2 } from "lucide-react";

export const Requirements = () => {
  return (
    <section
      id="requirements"
      data-testid="requirements-section"
      className="py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="eyebrow mb-3">Before You Book</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F1B16]">
            What you'll need at pick up.
          </h2>
          <p className="mt-4 text-[#3A332B] leading-relaxed">
            Quick and simple — bring these with you and we'll have you on the
            road fast.
          </p>
        </div>

        <ol className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {REQUIREMENTS.map((r, i) => (
            <li
              key={r.title}
              data-testid={`requirement-${i}`}
              className="relative bg-white border border-[#E5DCC9] rounded-2xl p-6 hover:border-[#D4A24C] transition"
            >
              <div className="absolute -top-3 -left-3 w-9 h-9 rounded-full bg-[#8B2332] text-white font-display font-bold flex items-center justify-center shadow-md">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="flex items-center gap-2 text-[#8B2332] mb-2">
                <CheckCircle2 className="w-4 h-4" />
                <span className="text-[11px] uppercase tracking-[0.18em] font-semibold">
                  Required
                </span>
              </div>
              <h3 className="font-display text-lg font-bold text-[#1F1B16]">
                {r.title}
              </h3>
              <p className="text-sm text-[#3A332B] mt-2 leading-relaxed">
                {r.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
